/**
 * 予約印刷モーダルウィンドウ 定数定義
 */
export const RESERVE_PRINT_MODAL_DEFINE = {
  /** 利用する検証ルールのキー値 */
  USE_RULE_KEY: {
    START_DATE: 'ReserveSearchCondition#searchStartDate',
    END_DATE: 'ReserveSearchCondition#searchEndDate'
  },

  /** 開始日と終了日の相関チェックエラーメッセージ */
  DATE_RANGE_ERROR_MESSAGE: {
    'ReserveSearchCondition#searchStartDate': '終了日より後の日付になっています。',
    'ReserveSearchCondition#searchEndDate': '開始日より前の日付になっています。'
  }
};



// WEBPACK FOOTER //
// ./src/app/feature/reserve-print-modal/reserve-print-modal.define.ts